export const DEFAULT_VAT_ID_PATTERN = /^[A-Z]{2}[A-Z0-9]{4,20}$/;

export const VAT_ID_PATTERNS = {
    AT: /^ATU\d{8}$/,
    BE: /^BE\d{10}$/,
    BG: /^BG\d{9,10}$/,
    CY: /^CY[A-Z0-9]{8}[A-Z]$/,
    CZ: /^CZ\d{8,10}$/,
    DE: /^DE\d{9}$/,
    DK: /^DK\d{8}$/,
    EE: /^EE\d{9}$/,
    ES: /^ES[A-Z0-9]{9}$/,
    FI: /^FI\d{8}$/,
    FR: /^FR[A-Z0-9]{11}$/,
    GR: /^GR\d{9}$/,
    HR: /^HR\d{11}$/,
    HU: /^HU\d{8}$/,
    IE: /^IE[A-Z0-9]{8,9}$/,
    IT: /^IT\d{11}$/,
    LT: /^LT(\d{9}|\d{12})$/,
    LU: /^LU\d{8}$/,
    LV: /^LV\d{11}$/,
    MT: /^MT\d{8}$/,
    NL: /^NL[A-Z0-9]{9}B[A-Z0-9]{2}$/,
    PL: /^PL\d{10}$/,
    PT: /^PT\d{9}$/,
    RO: /^RO\d{1,10}$/,
    SE: /^SE\d{12}$/,
    SI: /^SI\d{8}$/,
    SK: /^SK\d{10}$/,

    AL: /^AL[JKLM]\d{8}[A-Z]$/,
    BA: /^BA\d{12,13}$/,
    BY: /^BY\d{9}$/,
    CH: /^CHE\d{9}(MWST|TVA|IVA)?$/,
    GB: /^GB(\d{9}|\d{12}|GD\d{3}|HA\d{3})$/,
    MK: /^MK\d{13}$/,
    NO: /^NO\d{9}MVA$/,
    RS: /^RS\d{9}$/,
    SM: /^SM\d{5}$/,
    TR: /^TR\d{10}$/,
    UA: /^UA\d{12}$/,
} as const;

type VatIdCountryCode = keyof typeof VAT_ID_PATTERNS;

export function getVatIdPattern (value: string): RegExp {
    const countryCode = value.slice(0, 2) as VatIdCountryCode;

    return VAT_ID_PATTERNS[countryCode] ?? DEFAULT_VAT_ID_PATTERN;
}
